import { regular } from "@fortawesome/fontawesome-svg-core/import.macro";
import React from "react";
import Breadcrumb from "../../components/breadcrumb/Breadcrumb.component";
import { useTranslation } from "react-i18next";
import CandidateReport from "../../containers/report/CandidateReport.container";
import MetaComp from "../../components/meta-comp/MetaComp.component";

const ViewReport = () => {
  const { t } = useTranslation();
  const breadcrumbData = [
    {
      iconClass: regular("house"),
      link: "/",
    },
    {
      label: t("dashboard"),
      link: "/",
    },
    {
      label: t("view_report"),
    },
  ];
  return (
    <div
      className="cm-profile-container bg-white position-relative"
      style={{ minHeight: "calc(100vh - 110px)" }}
    >
      <Breadcrumb data={breadcrumbData} />
      <MetaComp title="Candidate Report Page" />
      <CandidateReport t={t} />
    </div>
  );
};

export default ViewReport;
